// extracted by mini-css-extract-plugin
export default {"lettersWrapper":"TextAnimator_lettersWrapper__DDd2N","word":"TextAnimator_word__RrxJ0","space":"TextAnimator_space__GpVFd","letter":"TextAnimator_letter__lvCjB"};